(function ($) {
  $(function () {
    //DONATION FORM
    //change donation frequency, switch between amounts
    $('.donation-frequency label').on('click', function (event) {
      var frequency = $(this).parent().find('input').val();
      $(this).closest('.hero-donation-form').find('.amount-buttons').hide();
      $(this)
        .closest('.hero-donation-form')
        .find('.amount-buttons-' + frequency)
        .show();
    });
    //set amound, send value to input
    $('.amount-buttons-button').on('click', function (event) {
      $(this)
        .closest('.hero-donation-form')
        .find('.amount-buttons-button')
        .removeClass('active');
      $(this).addClass('active');

      var currentAmount = $(this).val();
      $(this)
        .closest('.hero-donation-form')
        .find('.custom-amount-input')
        .val(currentAmount);

      return false;
    });
    //reset selected amount-buttons on custom-amount-input change
    $('.custom-amount-input').on('keyup', function (event) {
      $(this)
        .closest('.hero-donation-form')
        .find('.amount-buttons-button')
        .removeClass('active');
    });
    //send donation parameters to iRaiser
    $('.donate-button').on('click', function (event) {
      if (
        $(this)
          .closest('.hero-donation-form')
          .find('.custom-amount-input')
          .val() != ''
      ) {
        event.preventDefault();

        var data_url = $(this).closest('.hero-donation-form').attr('data-url');

        var frequency = $(this)
          .closest('.hero-donation-form')
          .find('input[type="radio"][name="frequency"]:checked')
          .val();
        var donation_amount =
          parseInt(
            $(this)
              .closest('.hero-donation-form')
              .find('.custom-amount-input')
              .val()
          ) * 100;
        var donation_url =
          data_url + '&amount=' + donation_amount + '&frequency=' + frequency;
        window.location.href = donation_url;
      }
    });
  });
})(jQuery);
